import { render } from "./add-domain.vue?vue&type=template&id=ffc1fcc4&ts=true&lang=pug"
import script from "./add-domain.vue?vue&type=script&lang=ts&setup=true"
export * from "./add-domain.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__